import { Controller } from "@hotwired/stimulus"

// Stimulus controller for the changelog/diff viewer component.
//
// Handles:
// - Expand/collapse of individual version diff panels
// - "Show all" to reveal all versions (appends query param and reloads)
//
// Usage (applied automatically by the _changelog.html.erb partial):
//   <div data-controller="changelog">
//     ...
//   </div>
//
export default class extends Controller {
  static targets = ["detail", "toggle"]

  // Toggle an individual detail panel open/closed.
  toggleDetail(event) {
    const button = event.currentTarget
    const index = this.toggleTargets.indexOf(button)
    if (index < 0) return

    const detail = this.detailTargets[index]
    if (!detail) return

    const isExpanded = button.getAttribute("aria-expanded") === "true"

    if (isExpanded) {
      detail.classList.remove("show")
      button.setAttribute("aria-expanded", "false")
      const textEl = button.querySelector(".toggle-text")
      if (textEl) textEl.textContent = "Show changes"
      this._swapChevron(button, "fa-chevron-down", "fa-chevron-right")
    } else {
      detail.classList.add("show")
      button.setAttribute("aria-expanded", "true")
      const textEl = button.querySelector(".toggle-text")
      if (textEl) textEl.textContent = "Hide changes"
      this._swapChevron(button, "fa-chevron-right", "fa-chevron-down")
    }
  }

  // "Show all N versions" button: reload the page with a query param.
  loadMore(event) {
    const url = new URL(window.location.href)
    url.searchParams.set("changelog_all", "1")
    window.location.href = url.toString()
  }

  // Helper: swap one FA class for another inside a button's <i> element.
  _swapChevron(button, from, to) {
    const icon = button.querySelector("i")
    if (icon) {
      icon.classList.remove(from)
      icon.classList.add(to)
    }
  }
}
